import { BurnId, BurnTemperatureSeries } from "firefly-shared-ts-domain";
import React, { FC } from "react";
import { SxProps } from "@mui/material";
import { Flue } from "firefly-my-chimney-ts-building";
import { DateTime, Duration } from "luxon";
import { BurnTimeSeriesAnonymizedChart } from "./BurnTimeSeriesAnonymizedChart";
import { BurnTimeSeriesSensitiveChart } from "./BurnTimeSeriesSensitiveChart";
import { notUndef } from "shared-ts-utils-core";
import { SizeClass } from "shared-ts-ui-responsive";

export interface BurnTimeSeriesChartProps {
  flue: Flue;
  burnTimeSeries: Array<BurnTemperatureSeries>;
  anonymizedTime?: boolean;
  selected: Array<BurnId>;
  selectedMonth?: DateTime;
  layout?: SizeClass;
  timeAxis?: {
    maxDuration?: Duration | undefined;
  };
  hideLegend?: boolean;
  hideMaxTemperatureReferenceLines?: boolean;
  hideAvgMaxTemperatureReferenceLines?: boolean;
  sx?: SxProps;
}

export const BurnTimeSeriesChart: FC<BurnTimeSeriesChartProps> = (props) => {
  const { flue, burnTimeSeries, selected, selectedMonth } = props;
  const anonymizedTime = props.anonymizedTime ?? false;

  if (anonymizedTime) {
    const burnTimeSeriesNonAnonymized = notUndef(
      burnTimeSeries,
      (burnTimeSeriesArray) =>
        burnTimeSeriesArray.map((burnTs) => burnTs.toNonSensitive())
    );
    return (
      <BurnTimeSeriesAnonymizedChart
        flue={flue}
        burnTimeSeries={burnTimeSeriesNonAnonymized}
        selected={selected}
        selectedMonth={selectedMonth}
        timeAxis={props.timeAxis}
        hideLegend={props.hideLegend}
        hideMaxTemperatureReferenceLines={
          props.hideMaxTemperatureReferenceLines
        }
        hideAvgMaxTemperatureReferenceLines={
          props.hideAvgMaxTemperatureReferenceLines
        }
        layout={props.layout}
        sx={props.sx}
      />
    );
  }

  return (
    <BurnTimeSeriesSensitiveChart
      flue={flue}
      burnTimeSeries={burnTimeSeries}
      selected={selected}
      selectedMonth={selectedMonth}
      timeAxis={props.timeAxis}
      hideMaxTemperatureReferenceLines={props.hideMaxTemperatureReferenceLines}
      hideAvgMaxTemperatureReferenceLines={
        props.hideAvgMaxTemperatureReferenceLines
      }
      layout={props.layout}
      sx={props.sx}
    />
  );
};
